const NativeBridge = {
  callbacksCount: 1,
  callbacks: {},
  resultForCallback: (callbackId, resultArray) => {
    try {
      const callbackFunction = NativeBridge.callbacks[callbackId]
      if (!callbackFunction) {
        return
      }
      callbackFunction(...resultArray)
    } catch (e) {
      alert(e)
    }
  },
  call: (functionName, args, callback) => {
    const hasCallback = callback && typeof callback === 'function'
    const callbackId = hasCallback ? NativeBridge.callbacksCount += 1 : 0

    if (hasCallback) {
      NativeBridge.callbacks[callbackId] = callback
    }

    let iframe = document.createElement('IFRAME')
    iframe.setAttribute('src', `js-frame:${functionName}:0:${encodeURIComponent(JSON.stringify(args))}`)
    document.documentElement.appendChild(iframe)
    iframe.parentNode.removeChild(iframe)
    iframe = null
  },
  iosJsToAppMessage: (message) => {
    NativeBridge.call('JsToAppMessage', [message], () => { })
  },
  androidJsToAppMessage: (message) => {
    window.MyHandler.JsToAppMessage(message)
  },
  getMobileOperatingSystem: () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera

    if (/android/i.test(userAgent)) {
      return 'Android'
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS'
    }

    return 'unknown'
  },
  jsToAppMessage: (message) => {
    const device = NativeBridge.getMobileOperatingSystem()

    if (device === 'iOS') {
      NativeBridge.iosJsToAppMessage(message)
      return
    }
    if (device === 'Android') {
      NativeBridge.androidJsToAppMessage(message)
    }
  }
}
export default {
  jsToAppMessage: (event) => {
    NativeBridge.jsToAppMessage(`{"event":"${event}", "data":""}`)
  }
}



// WEBPACK FOOTER //
// ./src/views/xbb/xbb-function.js